<router-outlet appTheme></router-outlet>
<ng-http-loader [entryComponent]="custome_loader" [filteredUrlPatterns]="filteredUrlPatterns"></ng-http-loader>